module.exports = __webpack_public_path__ + "images/patterns/dark/BrickHorizontal.99c5ab702a871cfced80.svg";